import { render } from "./SmartForm.vue?vue&type=template&id=0c476137&ts=true"
import script from "./SmartForm.vue?vue&type=script&lang=ts"
export * from "./SmartForm.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__